export const az = {
  title: 'VIIRS aktiv yanğınları',
  subtitle: '(gündəlik, 375 m, qlobal, NASA)',
  download_data: 'https://earthdata.nasa.gov/earth-observation-data/near-real-time/firms/active-fire-data',
  learn_more: 'https://earthdata.nasa.gov/earth-observation-data/near-real-time/firms/viirs-i-band-active-fire-data',
  content: [
    {
      label: 'Funksiya',
      value: 'Son 24 saat, 48 saat, 72 saat və ya 7 gün ərzində yanğın xəbərdarlığı məlumatlarını göstərir',
    },
    {
      label: 'Qətmə',
      value: '375 × 375 metr',
    },
    {
      label: 'Coğrafi əhatə',
      value: 'Qlobal',
    },
    {
      label: 'Mənbə',
      value: 'NASA',
    },
    {
      label: 'Tezlik',
      value: 'Gündə iki dəfə',
    },
    {
      label: 'Məzmun tarixi',
      value: 'Demək olar ki, real vaxt',
    },
    {
      label: 'Xəbərdarlıqlar',
      value:
        'Bütün yanğınlar aşkar edilmir. VIIRS-in müəyyən bir yanğını aşkar etməməsinin bir neçə səbəbi var. Yanğın peyk estakadaları arasında başlayıb və bitmiş ola bilər. Yanğın 375 metrlik pikseldə aşkar edilmək üçün çox kiçik və ya çox soyuq ola bilər. Bulud örtüyü, güclü tüstü və ya ağac örtüyü yanğını tamamilə gizlədə bilər.',
    },
    {
      label: 'Lisenziya',
      value:
        'Biz NASA/HQ tərəfindən maliyyələşdirilən NASA/GSFC/Yer Elmi Məlumat və İnformasiya Sistemi (ESDIS) tərəfindən idarə olunan LANCE FIRMS məlumat və təsvirlərindən istifadəni qəbul edirik. \n\nNASA Məlumat və Məlumat Siyasəti',
    },
  ],
  overview: {
    label: 'Ümumi baxış',
    value:
      'VIIRS aktiv yanğın məlumatları (VNP14IMGT) FIRMS (Resurs İdarəetmə Sistemi üçün Yanğın Məlumatı) üçün ən son yanğın monitorinqi məhsuludur ki, bu da qlobal yanğın yerlərini real vaxtda müəyyən edir. Məlumat Visible Infrared Imaging Radiometer Suite (VIIRS) sensorundan toplanır və aktiv yanğınları qeyd etmək üçün yanğın aşkarlama alqoritmi ilə işlənir. Xəritədəki hər bir nöqtə alqoritm tərəfindən işarələnmiş 375 metrlik pikselin mərkəzini təmsil edir.',
  },
  citation: {
    label: 'Sitat',
    value:
      'NASA FİRMALARI. "VIIRS Aktiv Yanğınlar." 29/01/2025-ci ildə Qlobal Meşə Nəzarəti vasitəsilə əldə edilib. www.globalforestwatch.org',
  },
};
